export default {
  about: "About",
  detail: "Detail",
  benefit: "Benefit",
  size: "Size",
  languageThai: "Thai",
  languageEnglish: "English",

  contact: {
    title: "Contact Us",
    website: "Website",
    email: "Email",
    contactNumber: "Contact Number",
    personalContactNumber: "Personal contact number",
    location: "Location",
    location2: "Location",
    contactInfo: "Contact Information",
    organizationPhone: "business Phone Number",
    enterPhoneNum: "Enter phone number",
    phoneRequired: "Please enter a phone number",
    phoneLengthValidation:
      "Please enter a 9 or 10-digit phone number",
    numberOnlyValidation: "Please enter numbers only",
    to: "to",
    phoneOwnerName: "Phone Owner Name",
    enterPhoneOwnerName: "Enter phone owner name",
    phoneOwnerNameRequired: "Please enter the phone owner's name",
    thaiOrEnglishOnlyValidation: "Please enter Thai or English characters only",
    addPhoneNumber: "Add Phone Number",
    emailRequired: "Please enter an email",
    enterEmail: "Enter email",
    max100Characters: "Maximum 100 characters",
    emailFormatValidation:
      "Please enter a valid email format such as name@example.com",
    enterWebsite: "Enter website",
    example: "Example",
    branch: "Branch",
    setMainBranch: "Set as Main Branch",
    addBranch: "Add Branch",
    viewInfo: "View Information",
    locationGuideMessage: "You can add a location using the 'Add Branch' button below",
    noLocationData: "Location data not found",

    organizationSize: "Organization Size",
    selectOrganizationSize: "Select organization size",

    enterAbout: "Enter about information",
    aboutRequired: "Please enter about information",

    enterBranch: "Enter branch",
    branchRequired: "Please enter branch",

    addressDetail: "No. / Village / Building",
    enterAddressDetail: "Enter No. / Village / Building",
    locationRequired: "Please enter location",

    province: "Province",
    selectProvince: "Select province",
    provinceRequired: "Please select a province",

    noSearchData: "No data found for your search",

    district: "District / Area",
    selectDistrict: "Select district/area",
    districtRequired: "Please select district/area",

    subDistrict: "Subdistrict",
    selectSubDistrict: "Select subdistrict",
    subDistrictRequired: "Please select subdistrict",

    postalCode: "Postal Code",
    enterPostalCode: "Enter postal code",
  },

  btn: {
    edit: "Edit",
  },

  img: {
    selectImage: "Select Image",
    banner: "Banner",
    logo: "Logo",
    changeImage: "Change Image",
    recommendedBannerSize: "Recommended Banner Size",
    maxUploadSize: "Maximum upload file size",
    fileFormat: "File format",
    uploadLogoRequired: "Please upload a logo image",
  },

  business: {
    businessInfo: "Business Information",
    generalInfo: "General Information",
    companyName: "Company Name",
    enterCompanyName: "Enter company name",
    organizationType: "business Type",
    selectOrganizationType: "Select business type",
    businessCategory: "Business Category",
    selectBusinessCategory: "Please select a business category",
    aboutRequired: "Please provide company details",
    max2000Characters: "Text exceeds 2000 characters",
  },
};
